import { api } from "../api";

/**
 * deleteGeofenceByIdAndCustomerAndDepartment - Function that deletes on database an existing geofence by department id  
 * /geofences/{customerId}/{departmentId}/{id}  
 * method DELETE  
 * Do not use (disabled function)
 * @async-function
 */
const deleteGeofenceByIdAndCustomerAndDepartment = async (token: string, customerId: number, departmentId: number, id: number) => {
    const response = await api.delete(
        `/geofences/${customerId}/${departmentId}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default deleteGeofenceByIdAndCustomerAndDepartment;